import Image from "../../../elements/Image";
import Button from "../../../form/Button";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import { useEffect } from "react";

const TakeActionStepTwo = ({
  data,
  setStep,
  formData,
  setFormData = () => {},
  backHandler = () => {},
}) => {
  const validation = {
    firstName: { required: true, message: "First name is required" },
    lastName: { required: true, message: "Last name is required" },
    email: [
      {
        type: "email",
        required: true,
        message: "Enter valid Email",
      },
    ],
  };

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
  });

  const onSubmit = async (values) => {
    setFormData(values);
    setStep(3);
  };
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setFieldsValue(formData);
    }
  }, [formData]);

  return (
    <>
      <div className="relative py-10 space-y-10">
        <div className="space-y-6">
          <div className="h-20">
            {data?.details?.takeAction?.image?.url ? (
              <Image
                src={data?.details?.takeAction?.image?.url}
                alt={""}
                effect="blur"
                classes="object-contain object-left"
              />
            ) : (
              <div className="w-32 h-12 bg-gray-300 animate-pulse" />
            )}
          </div>
        </div>
        <form onSubmit={(event) => handleSubmit(event, onSubmit)}>
          <div className="relative">
            <div className="relative mb-6">
              <Input
                label={"First Name"}
                labelClasses={"mb-2 !text-gable-green !text-base"}
                inputClasses={"bg-transparent rounded-lg !h-12 !text-base"}
                inputPlaceholder={"Enter Your First Name"}
                inputName="firstName"
                value={values?.firstName}
                onChange={handleChange}
                {...formValidate(errors, "firstName")}
              />
            </div>
            <div className="relative mb-6">
              <Input
                label={"Last Name"}
                labelClasses={"mb-2 !text-gable-green !text-base"}
                inputClasses={"bg-transparent rounded-lg !h-12 !text-base"}
                inputPlaceholder={"Enter Your Last Name"}
                value={values?.lastName}
                inputName="lastName"
                onChange={handleChange}
                {...formValidate(errors, "lastName")}
              />
            </div>
            <div className="relative mb-6">
              <Input
                label={"Email"}
                labelClasses={"mb-2 !text-gable-green !text-base"}
                inputClasses={"bg-transparent rounded-lg !h-12 !text-base"}
                inputPlaceholder={"Enter email address"}
                value={values?.email}
                inputName="email"
                onChange={handleChange}
                {...formValidate(errors, "email")}
              />
            </div>
            <div className="relative flex justify-center gap-4">
              <Button
                buttonLabel={"Back"}
                buttonType={"button"}
                buttonClasses={"!h-10 xls:!h-12 !rounded-full !px-6 xls:!px-10 !border !border-chestnut-rose !bg-white !text-chestnut-rose"}
                buttonLabelClasses={"text-base xls:!text-lg"}
                buttonFunction={() => backHandler()}
              />
              <Button
                buttonLabel={"Take Action"}
                buttonClasses={"!h-10 xls:!h-12 !rounded-full !px-6 xls:!px-10"}
                buttonHasLink={""}
                buttonType="submit"
                buttonLabelClasses={"text-base xls:!text-lg"}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default TakeActionStepTwo;
